import request from '@/utils/request'

const monitorPlaneApi = {
  monitor_plane_in_out_list: '/monitor/plane/in_out/',
  monitor_plane_in_out_create: '/monitor/plane/in_out/',
  monitor_plane_in_out_update: '/monitor/plane/in_out/',
  monitor_plane_in_out_delete: '/monitor/plane/in_out/',
  monitor_plane_record_list: '/monitor/plane/pay_record/',
  monitor_plane_record_create: '/monitor/plane/pay_record/',
  monitor_plane_record_update: '/monitor/plane/pay_record/',
  monitor_plane_record_delete: '/monitor/plane/pay_record/',
  monitor_plane_statistics: '/monitor/plane/statistics/'
}

/**
 * 列表
 */
export function monitor_plane_in_out_list (parameter) {
  return request({
    url: monitorPlaneApi.monitor_plane_in_out_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function monitor_plane_in_out_create (data) {
  return request({
    url: monitorPlaneApi.monitor_plane_in_out_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}
/**
 * 修改
 */
export function monitor_plane_in_out_update (data, id) {
  return request({
    url: monitorPlaneApi.monitor_plane_in_out_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}
/**
 * 删除
 */
export function monitor_plane_in_out_delete (id) {
  return request({
    url: monitorPlaneApi.monitor_plane_in_out_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 手动添加租金账单
 */
export function monitor_plane_record_list (parameter) {
  return request({
    url: monitorPlaneApi.monitor_plane_record_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}

/**
 * 添加减免
 */
export function monitor_plane_record_create (data) {
  return request({
    url: monitorPlaneApi.monitor_plane_record_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}

/**
 * 删除减免
 */
export function monitor_plane_record_update (data, id) {
  return request({
    url: monitorPlaneApi.monitor_plane_record_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}

/**
 * 添加减免
 */
export function monitor_plane_record_delete (id) {
  return request({
    url: monitorPlaneApi.monitor_plane_record_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function monitor_plane_statistics (parameter) {
  return request({
    url: monitorPlaneApi.monitor_plane_statistics,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
